import { render } from "./regs.vue?vue&type=template&id=a9c78834&scoped=true"
import script from "./regs.vue?vue&type=script&lang=js"
export * from "./regs.vue?vue&type=script&lang=js"

import "./regs.vue?vue&type=style&index=0&id=a9c78834&lang=scss&scoped=true"

import exportComponent from "E:\\zhouwang\\work\\web_dev\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a9c78834"]])

export default __exports__